import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import { css } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  border: '1px solid #e5e5e5',
  padding: '24px',
  get boxShadow() {
    return theme.boxShadow;
  },
  get borderRadius() {
    return theme.largeBorderRadius;
  },
  headerHeight: '48px',
  headerFontSize: '14px',
  bgColor: '#fff',
  large: {
    padding: '32px',
    headerHeight: '48px'
  },
  small: {
    padding: '16px',
    headerHeight: '48px'
  },
  mini: {
    padding: '8px',
    headerHeight: '32px'
  }
};
var card;
setDefault(function () {
  card = deepDefaults(theme, {
    card: defaults
  }).card;
  makeStyles == null || makeStyles.clearCache();
});
var sizes = ['large', 'small', 'mini'];
export var makeStyles = cache(function makeStyles(k) {
  return /*#__PURE__*/css("border-radius:", card.borderRadius, ";background:", card.bgColor, ";.", k, "-card-header{height:", card.headerHeight, ";padding:0 ", card.padding, ";display:flex;align-items:center;}.", k, "-card-title{font-size:", card.headerFontSize, ";flex:1;}.", k, "-card-extra{display:flex;align-items:center;}.", k, "-card-body{padding:0 ", card.padding, " ", card.padding, ";}&.", k, "-shadow{box-shadow:", card.boxShadow, ";}&.", k, "-none{box-shadow:none;}&.", k, "-border{border:", card.border, ";.", k, "-card-header{border-bottom:", card.border, ";}.", k, "-card-body{padding-top:", card.padding, ";}}&.", k, "-no-header{.", k, "-card-body{padding-top:", card.padding, ";}}&.", k, "-card-grid{.", k, "-card-body{display:flex;padding:0;}&.", k, "-border{.", k, "-card-column:not(:last-of-type){border-right:", card.border, ";}}}.", k, "-card-column{display:flex;align-items:center;padding:", card.padding, ";&.", k, "-fluid{flex:1;}&.", k, "-center{justify-content:center;}}", _mapInstanceProperty(sizes).call(sizes, function (size) {
    var _card$size = card[size],
      padding = _card$size.padding,
      headerHeight = _card$size.headerHeight;
    return /*#__PURE__*/css("&.", k, "-", size, "{.", k, "-card-header{padding:0 ", padding, ";height:", headerHeight, ";}.", k, "-card-body{padding:0 ", padding, " ", padding, ";}&.", k, "-border,&.", k, "-no-header{.", k, "-card-body{padding-top:", padding, ";}}.", k, "-card-column{padding:", padding, ";}}");
  }), ";");
});